import Localization from '../../other/localization';

const localization = new Localization();

if (typeof window !== 'undefined' && $.validator) {
    $.extend(
        $.validator.messages,
        {
            required: localization.getMessage('validation-message-required'),
            email: localization.getMessage('validation-message-email'),
            minlength: $.validator.format(
                localization.getMessage('validation-message-minlength'),
            ),
            maxlength: $.validator.format(
                localization.getMessage('validation-message-maxlength'),
            ),
            url: localization.getMessage('validation-message-url'),
            number: localization.getMessage('validation-message-number'),
            equalTo: localization.getMessage('validation-message-equalto'),
        },
    );
}
